var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "未入力一括催促",
        top: "5vh",
        width: "580px",
        visible: _vm.dialogVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "vab-form",
            {
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "0px",
              },
            },
            [
              _c(
                "vab-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "vab-col",
                    { staticClass: "input_per", attrs: { span: 14 } },
                    [
                      _c("vab-date-picker", {
                        attrs: {
                          type: "date",
                          label: "入力期限",
                          "value-format": "yyyy/MM/dd",
                          format: "yyyy/MM/dd",
                          prop: "planContractStartDate",
                          "label-width": "110px",
                          validate: "required",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mg12 flex_end" },
            [_c("vab-button", { attrs: { "btn-list": _vm.btnUpdate } })],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }